import { Cell, Grid, HFlow } from 'bold-ui'
import { useFlags } from 'config/useFlagsContext'
import bridge_logo from 'images/bridge.svg'
import esus_logo from 'images/sobre/logo-esus.svg'
import esus_gov_logo from 'images/sobre/logo-esus-gov.svg'
import ufsc_logo from 'images/sobre/logo-ufsc.svg'

export function SobreFooterView() {
  const { PERIODO_ELEITORAL_ENABLED } = useFlags()

  return (
    <div>
      <hr />
      <Grid>
        <Cell size={6}>
          <HFlow hSpacing={1} alignItems='center'>
            <img src={ufsc_logo} alt='Logo da Universidade Federal de Santa Catarina' />
            <img src={bridge_logo} alt='Logo do Laboratório Bridge' />
          </HFlow>
        </Cell>
        <Cell size={6}>
          <HFlow hSpacing={1} alignItems='center' justifyContent='flex-end'>
            <img src={PERIODO_ELEITORAL_ENABLED ? esus_logo : esus_gov_logo} alt='Logo do Ministério da Saúde' />
          </HFlow>
        </Cell>
      </Grid>
    </div>
  )
}
